import RequestCancelledError from '../error/RequestCancelledError';
import logger from './logger';
const errorHandler = {
    /**
     * @param error
     * @return boolean
     *   Whether the error was handled.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(error) {
        if (error.name === RequestCancelledError.code) {
            logger.warn(error.message);
            return true;
        }
        /* tslint:disable:no-console */
        console.error(error);
        return false;
    },
    promise() {
        return error => errorHandler.handleError(error);
    },
};
export default errorHandler;
//# sourceMappingURL=errorHandler.js.map